import { useEffect } from 'react';

// Shared modal shell — fixed overlay + centered panel. Closes on Escape and
// on backdrop click. Children render the body; the header bar is optional.
export default function ModalShell({ title, eyebrow, onClose, children, widthClass }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose?.();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-40 bg-black/60 flex items-start sm:items-center justify-center p-4 overflow-y-auto"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className={`bg-white w-full ${widthClass || 'max-w-5xl'} rounded border border-hxd-border shadow-xl my-8 max-h-[88vh] flex flex-col`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-hxd-border-soft sticky top-0 bg-white rounded-t z-10">
          <div className="min-w-0">
            {eyebrow && (
              <div className="font-display text-[10px] font-bold tracking-display-md uppercase text-hxd-orange truncate">
                {eyebrow}
              </div>
            )}
            <div className="font-display text-[16px] font-bold text-hxd-ink truncate">
              {title}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="hxd-btn hxd-btn-ghost hxd-btn-sm"
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="px-5 py-4 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
